import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageCareerApplication } from "../../components/Contact/ManageCareerApplication";
export const CareerApplicationManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageCareerApplication />
        </div>
      </div>
    </div>
  );
};
